import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';

export const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation('common');
  const { refresh } = useAuth();

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'it', label: 'Italiano' },
    { code: 'he', label: 'עברית' },
  ];

  const changeLanguage = async (lng: string) => {
    await i18n.changeLanguage(lng);
    try {
      await fetch('/api/me', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ language: lng })
      });
      // Pull the saved value back into the auth context so `user.language` agrees with what is on screen.
      // Without this the context keeps the OLD language indefinitely, and anything that reads it — today
      // I18nWatcher, tomorrow something else — is working from a value the user already changed.
      await refresh();
    } catch (err) {
      console.error('Failed to persist language choice:', err);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-gray-500" />
      <select
        value={i18n.language}
        data-testid="language-select"
        onChange={(e) => changeLanguage(e.target.value)}
        // min-h-[44px]: the select rendered 19px tall — fine with a mouse, a poke with a thumb.
        className="bg-transparent text-sm text-gray-700 border-none focus:ring-0 cursor-pointer min-h-[44px]"
        aria-label={t('common.language')}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
};
